import React from "react";
import styled from "styled-components";

const Cont = styled.div`
  padding-bottom: 100px;
`;

const Content = ({ children, noInr }) => {
  if (noInr) {
    return <Cont>{children}</Cont>;
  }
  return (
    <Cont>
      <div className="inr">{children}</div>
    </Cont>
  );
};

export default Content;
